import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";

import { authApi } from "@/api";
import { env } from "@/configs/env";
import { useSessionStore } from "@/store";

/**
 * Chiqish oqimi.
 *
 * Ikki joyda kerak — sarlavhadagi menyu va sidebar footeri — va u
 * uchta ishni ketma-ket bajaradi. Ularning birini unutish "chiqdim,
 * lekin eski ma'lumot ko'rinib turibdi" degan holatga olib keladi,
 * shuning uchun oqim bitta joyda turadi.
 *
 * Serverdagi xato ham chiqishni TO'XTATMAYDI: odam chiqmoqchi, va
 * mahalliy sessiyani tozalash baribir to'g'ri ish.
 */
export function useLogout() {
  const clear = useSessionStore(state => state.clear);
  const queryClient = useQueryClient();
  const [isPending, setIsPending] = useState(false);

  const signOut = async () => {
    setIsPending(true);

    try {
      await authApi.logout();
    } finally {
      clear();
      // Butun kesh tozalanadi: unda oldingi foydalanuvchining
      // ma'lumotlari qolgan bo'lishi mumkin.
      queryClient.clear();
      window.location.assign(env.VITE_WEB_URL);
    }
  };

  return { signOut, isPending };
}
